import { render, staticRenderFns } from "./v-upload.vue?vue&type=template&id=ab642f34&scoped=true&"
import script from "./v-upload.vue?vue&type=script&lang=js&"
export * from "./v-upload.vue?vue&type=script&lang=js&"
import style0 from "./v-upload.vue?vue&type=style&index=0&id=ab642f34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab642f34",
  null
  
)

export default component.exports